var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class Float {
    // eslint-disable-next-line no-useless-constructor
    constructor(layout, options) {
        this.layout = layout;
        this.options = options;
        this.position = {};
    }
    contains(div) {
        return this.floating && div.isSameNode(this.floating.elm);
    }
    render(animate = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.floating) {
                return;
            }
            // set initial position for boxes
            if (!this.floating.state.completed) {
                this.floating.elm.style.transitionDuration = ".0s";
                this.floating.elm.style.top = `${this.floating.state.top}px`;
                this.floating.elm.style.left = `${this.floating.state.left}px`;
                this.floating.elm.style.width = `${this.floating.state.width}px`;
                this.floating.elm.style.height = `${this.floating.state.height}px`;
                this.floating.state.completed = true;
            }
            // give some time for transition to register initial position
            yield new Promise((resolve) => setTimeout(resolve, 0));
            this.floating.elm.style.transitionDuration = animate ? "400ms" : ".0s";
            this.floating.elm.style.top = `${this.floating.transition.top}px`;
            this.floating.elm.style.left = `${this.floating.transition.left}px`;
            this.floating.elm.style.width = `${this.floating.transition.width}px`;
            this.floating.elm.style.height = `${this.floating.transition.height}px`;
            this.floating.elm.style.visibility = "visible";
            this.floating.transition.completed = true;
            this.floating.state = this.floating.transition;
            if (animate)
                yield new Promise((resolve) => setTimeout(resolve, 300));
        });
    }
    calculate() {
        this.floating.transition = {
            height: this.floating.height,
            width: this.floating.height * this.floating.ratio,
            top: this.position.top || this.options.margin,
            left: this.position.left || this.options.margin,
            completed: false,
        };
        if (this.position.right) {
            this.floating.transition.left =
                this.options.width -
                    this.position.right -
                    this.floating.transition.width;
        }
        if (this.position.bottom) {
            this.floating.transition.top =
                this.options.height -
                    this.position.bottom -
                    this.floating.transition.height;
        }
        if (!this.floating.state) {
            const box = this.layout.getRemovalPending(this.floating.elm);
            this.floating.state = box
                ? box.state
                : {
                    width: this.floating.transition.width / 4,
                    height: this.floating.transition.height / 4,
                    top: this.floating.transition.top +
                        this.floating.transition.height / 2,
                    left: this.floating.transition.left +
                        this.floating.transition.width / 2,
                    completed: false,
                };
        }
    }
    /**
     * add or reset new box
     * @param div the element to make floating
     * @param options aspect ratio, height, and margins
     */
    set(div, options = {}) {
        if (this.floating) {
            return;
        }
        this.floating = {
            elm: div,
            ratio: options.ratio || 16 / 9,
            height: options.height || 200,
        };
        this.floating.elm.style.transitionProperty =
            "top, left, height, width, visibility, opacity";
        this.floating.elm.style.transitionTimingFunction = "ease";
        this.floating.elm.style.transitionDuration = ".4s";
        this.position = {
            top: options.top,
            right: options.right,
            bottom: options.bottom,
            left: options.top,
        };
        if (!this.position.left && !this.position.right) {
            this.position.right = this.options.margin;
        }
        if (!this.position.top && !this.position.bottom) {
            this.position.top = this.options.margin;
        }
        this.calculate();
    }
    /**
     * unset floating element
     */
    unset() {
        if (!this.floating) {
            return;
        }
        this.floating.transition = {
            width: this.floating.state.width / 4,
            height: this.floating.state.height / 4,
            top: this.floating.state.top + this.floating.state.height / 2,
            left: this.floating.state.left + this.floating.state.width / 2,
            completed: false,
        };
        this.layout.pendingRemoval.set(this.floating.elm, this.floating);
        this.floating = null;
    }
    update(container, float = {}) {
        this.options = Object.assign(Object.assign({}, this.options), container);
        if (this.floating) {
            this.position = Object.assign(Object.assign({}, this.position), float);
            this.floating = Object.assign(Object.assign({}, this.floating), float);
            this.calculate();
        }
    }
}
